import { z } from 'zod';

export const PostfixDimensionPropertyPathSchema = z.object({
  source: z.literal('dimensions'),
  dimensionId: z.string(),
  variablePath: z.string().optional(),
});

export type PostfixDimensionPropertyPath = z.infer<typeof PostfixDimensionPropertyPathSchema>;

export const PostfixTagVariablePropertyPathSchema = z.object({
  source: z.literal('tags.variableConfigs'),
  tagId: z.string(),
  variableId: z.string().optional().nullable(),
  dimensionId: z.string().optional(),
  variablePath: z.string().optional().nullable(),
});

export type PostfixTagVariablePropertyPath = z.infer<typeof PostfixTagVariablePropertyPathSchema>;

export const PostfixTagRequestTypesSchema = z.object({
  source: z.literal('tags.requestTypeConfigs'),
  requestTypeId: z.string(),
  tagId: z.string(),
});

export type PostfixTagRequestTypes = z.infer<typeof PostfixTagRequestTypesSchema>;

export const PostfixPropertyPathSchema = z.union([
  z.string(),
  PostfixDimensionPropertyPathSchema,
  PostfixTagVariablePropertyPathSchema,
  PostfixTagRequestTypesSchema,
]);

export type PostfixPropertyPath = z.infer<typeof PostfixPropertyPathSchema>;
